const businessGroupActionTypes = {

    START_GET_BUSINESS_GROUP: 'START_GET_BUSINESS_GROUP',
    GET_BUSINESS_GROUPS_SUCCESS: 'GET_BUSINESS_GROUPS_SUCCESS',
    GET_BUSINESS_GROUPS_FAILURE: 'GET_BUSINESS_GROUPS_FAILURE',

    START_ADD_BUSINESS_GROUP: 'START_ADD_BUSINESS_GROUP',
    ADD_BUSINESS_GROUP_SUCCESS: 'ADD_BUSINESS_GROUP_SUCCESS',
    ADD_BUSINESS_GROUP_FAILURE: 'ADD_BUSINESS_GROUP_FAILURE',

    START_UPDATE_BUSINESS_GROUP: 'START_UPDATE_BUSINESS_GROUP',
    UPDATE_BUSINESS_GROUP_SUCCESS: 'UPDATE_BUSINESS_GROUP_SUCCESS',
    UPDATE_BUSINESS_GROUP_FAILURE: 'UPDATE_BUSINESS_GROUP_FAILURE',

    START_DELETE_BUSINESS_GROUP: 'START_DELETE_BUSINESS_GROUP',
    DELETE_BUSINESS_GROUP_SUCCESS: 'DELETE_BUSINESS_GROUP_SUCCESS',
    DELETE_BUSINESS_GROUP_FAILURE: 'DELETE_BUSINESS_GROUP_FAILURE',

    SELECT_BUSINESS_GROUP: 'SELECT_BUSINESS_GROUP',
    UNSELECT_BUSINESS_GROUP: 'UNSELECT_BUSINESS_GROUP',

    RESET_STATE_INFO: 'RESET_STATE_INFO',
};

export default businessGroupActionTypes;